module.exports = __webpack_public_path__ + "8e5589d6c09a37332cae7bafcbe96243.svg";